'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function sign(n) {
  if (n === 0)
    return 0;
  return n < 0 ? -1 : 1;
}

exports.sign = sign;
//# sourceMappingURL=sign.js.map
